import { useMemo, useContext, ReactNode } from "react";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { createRegisteredContext, getContext } from "react-singleton-context";

export type ContextValue = AnalyticsBrowser;

export const AnalyticsContext = createRegisteredContext<
  ContextValue | undefined
>("AnalyticsContext", undefined);

type Props = {
  children: ReactNode;
  writeKey: string;
};

export const AnalyticsProvider = ({ children, writeKey }: Props) => {
  const analytics = useMemo(
    () => AnalyticsBrowser.load({ writeKey }),
    [writeKey],
  );

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = (): ContextValue => {
  const result = useContext(getContext(AnalyticsContext));
  if (!result) {
    throw new Error("Analytics Context used outside of Provider");
  }
  return result;
};
